import React, { useState } from 'react';

import { useSelector } from 'react-redux';

import { Phone, ShareNetwork } from 'components/shared/Icon/phosphorIcons';
import i18n from 'i18n';
import { itineraryWithoutEmptyPagesSelector } from 'store/itinerariesItem/selectors';
import { removeAIBlocksFromProposal, useItinerariesItemSaveHandler } from 'utils/itineraries/functions/builderUtils';
import { IProposal } from 'utils/itineraryDetails/types';

import { useProposalDifferenceHandler } from '../../../shared/functions';
import { IIcon } from '../../../shared/ItinerariesItemLanding/LandingActions/types';

export const iconsConfig: IIcon[] = [
  {
    type: 'share',
    icon: <ShareNetwork data-tip="" data-for="share" />,
    onClick: () => {},
    hint: i18n.t('proposal_content.copy_link'),
    isDisabled: true,
  },
  {
    type: 'phone',
    icon: <Phone data-tip="" data-for="phone" />,
    onClick: () => {},
    hint: i18n.t('proposal_content.contact.travel_consultant'),
    isDisabled: true,
  },
];

export function useActionsButtons() {
  const itineraryItem = useSelector(itineraryWithoutEmptyPagesSelector);
  const pages = itineraryItem?.landing?.pages || [];
  const { updatedPages, setNewPages } = useProposalDifferenceHandler(pages);
  const [submitting, setSubmitting] = useState(false);

  const handleSave = useItinerariesItemSaveHandler({
    onPrepareSaveData: (newItinerary: IProposal) => {
      return removeAIBlocksFromProposal(newItinerary);
    },
    onAfterSave: (newItinerary: IProposal) => {
      // FIXME: fix type assertion
      setNewPages(newItinerary.landing.pages as never[]);
    },
  });
  const onSave = async () => {
    try {
      setSubmitting(true);
      await handleSave({
        pages: updatedPages,
        customStyles: itineraryItem?.customStyles,
        customFonts: itineraryItem?.customFonts,
        itinerary: {
          landingConfig: itineraryItem?.landingConfig,
        },
      });
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    onSave,
  };
}
